import 'custom-event-polyfill'

/**
 * Dispatch a custom created event
 * @param {String} name - name of the event
 * @param {Object} detail - data of the event
 */
export const dispatchCustomEvent = (name, detail = {}) => {
    const customEvent = new CustomEvent(name, { detail })

    window.dispatchEvent(customEvent)
}
